import Api from "../helpers/api";

export const vratZoznamStanic = async () => {
  try {
    const response = await Api.get(`/api/v1/meteo/meteo`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
